import { Button, Result } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import '../assets/css/unauthorized.css';

const Unauthorized = () => {
    const { logout } = useAuth0();

    const GoToLogin = () => {
        logout({ logoutParams: { returnTo: window.location.origin } });
        window.localStorage.clear();
    };

    return (
        <div className="unauthorized-page" style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}>
            <Result
                status="403"
                title="403"
                subTitle="Sorry, you are not authorized to access this page."
                extra={[
                    <Button
                        key="login"
                        icon={<LoginOutlined />}
                        onClick={() => GoToLogin()}
                    >
                        Back to Login
                    </Button>
                ]}
            />
        </div>
    );
};

export default Unauthorized;